import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { EntryPoint, TripType } from '../../models';
import { setActiveProduct } from '../../redux/activeProduct/actions';
import { setHotelTripType } from '../../redux/currentSearch/actions';

export const WithHotelEntryPoint = (Component) => {
    const HOC = (props) => {
        const dispatch = useDispatch();

        useEffect(() => {
            dispatch(setActiveProduct(EntryPoint.HOTELS));
            dispatch(setHotelTripType(TripType.ROUND_TRIP));
        }, [dispatch]);

        return <Component {...props} />;
    };
    HOC.displayName = Component.displayName || Component.name || 'HotelEntryPoint';
    return HOC;
};
